module.exports = __webpack_public_path__ + "img/dokumentARfilm.e4ca8877.jpg";